export class HowItWorksAnimation {
  dotLottie: any = null
  observer: IntersectionObserver | null = null
  container: HTMLElement
  playerElement: HTMLElement | null
  loaded: boolean = false

  constructor(container: HTMLElement) {
    this.container = container
    this.playerElement = container.querySelector("[data-lottie-player]")

    if (!this.playerElement) {
      console.error("Lottie player element not found")
      return
    }

    this.setupIntersectionObserver()
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: "50px",
      threshold: 0.1,
    }

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.loaded) {
          this.loadAndPlayAnimation()
          this.loaded = true
          this.observer?.disconnect()
        }
      })
    }, options)

    this.observer.observe(this.container)
  }

  async loadAndPlayAnimation() {
    if (!this.playerElement) return

    try {
      // Dynamically import both the dotLottie library and the animation file
      const [{ DotLottieWorker }, { default: animationUrl }] = await Promise.all([
        import("@lottiefiles/dotlottie-web"),
        import("images/home/prosumer/if-then.lottie?url"),
      ])

      const canvas = document.createElement("canvas")
      canvas.style.width = "100%"
      canvas.style.height = "100%"
      this.playerElement.appendChild(canvas)

      this.dotLottie = new DotLottieWorker({
        canvas,
        src: animationUrl,
        workerId: "dotlottie-shared",
        loop: true,
        autoplay: true,
      })

      if (window.App?.Utils?.logCustomDatadogAction) {
        window.App.Utils.logCustomDatadogAction("how_it_works_animation_loaded", {
          platform: window.innerWidth <= 768 ? "mweb" : "web",
        })
      }
    } catch (error) {
      console.error("Failed to load dotLottie animation:", error)
    }
  }
}

window.addEventListener("load", () => {
  const container = document.querySelector("[data-animation-container]") as HTMLElement
  if (container) {
    new HowItWorksAnimation(container)
  }
})
